import axios from "axios";
export const Tasks_URL = "api/quotes-list";
export const TASKS = "quotes-list";
export const SEARCH = "/search-contact-deals";
export const KYC_LIST = "kyc-list";
export const UPDATEKYCSTATUS = "kyc/update-kyc-status";

export function getAllProducts() {
  return axios.get(Tasks_URL);
}
/**
 * Fetch a page of the Onboarding (KYC) list.
 *
 * The status filter's "name_check_pending" option is not a kyc_status: it is
 * sent as `name_check=pending`, listing every order whose ID name does not
 * match and is awaiting review, whatever its contract stage.
 *
 * @param {Object} queryParams Paging, sorting and filter values
 * @returns {Promise}
 */
export function findKyc(queryParams) {
  const selected = queryParams?.filter?.status || "";
  const nameCheck = selected === "name_check_pending" ? "pending" : "";
  const status = nameCheck ? "" : selected;

  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + KYC_LIST}?page=${queryParams.pageNumber
    }&per_page=${queryParams.pageSize}&sort_by=${queryParams.sortField
    }&sort_dir=${queryParams.sortOrder}&search_keyword=${queryParams.filter.search
    }&status=${status}&name_check=${nameCheck}`
  );
}

// udpate the kyc status
export function updateKycStatus(data) {
  return axios.post(
    import.meta.env.REACT_APP_SITE_URL + UPDATEKYCSTATUS,
    data
  );
}
/**
 * Approve an ID whose name did not match the order. The backend then issues
 * the eContract: in the name on the ID (the booking is renamed to it) when
 * `useIdName` is true, otherwise in the booking name.
 *
 * `use_id_name` is always sent, as a boolean: the backend keeps the booking
 * name when it is missing, so the caller must say which it wants rather than
 * rely on a default either side.
 *
 * @param {number|string} orderId
 * @param {string} note How the name was checked (required by the backend)
 * @param {boolean} useIdName Rename the booking to the name on the ID
 * @returns {Promise}
 */
export function approveNameCheck(orderId, note, useIdName) {
  return axios.post(
    `${import.meta.env.REACT_APP_SITE_URL}kyc/${orderId}/name-check/approve`,
    { note, use_id_name: useIdName === true }
  );
}

/**
 * Email the customer a new ID verification link after a name mismatch. The
 * eContract follows once the new ID matches.
 *
 * @param {number|string} orderId
 * @returns {Promise}
 */
export function reRequestNameCheck(orderId) {
  return axios.post(
    `${import.meta.env.REACT_APP_SITE_URL}kyc/${orderId}/name-check/re-request`
  );
}
